






















































































import { Vue, Component, Watch, Prop }  from 'vue-property-decorator'
import { mapGetters, mapState }         from 'vuex'
import { FontAwesomeIcon }              from '@fortawesome/vue-fontawesome'
import ECharts                          from 'vue-echarts'
import { use }                          from 'echarts/core'
import { exportDivElementAsImage }          from '@/utils/helpers'
import { Ability }                      from '@/types/Ability'
import {
    CanvasRenderer
} from 'echarts/renderers'
import {
    BarChart, BoxplotChart, LineChart, ScatterChart
} from 'echarts/charts'
import {
    DatasetComponent,
    DataZoomComponent,
    GridComponent,
    LegendComponent,
    MarkLineComponent,
    TitleComponent,
    ToolboxComponent,
    TooltipComponent,
    TransformComponent
} from 'echarts/components'
import { BarRuleType, BarTypePass } from '@/types/Barre'

use([
    CanvasRenderer,
    BarChart,
    TooltipComponent,
    GridComponent,
    DatasetComponent,
    TitleComponent,
    TooltipComponent,
    GridComponent,
    TransformComponent,
    BoxplotChart,
    ScatterChart,
    CanvasRenderer,
    ToolboxComponent,
    DataZoomComponent,
    LineChart,
    LegendComponent,
    MarkLineComponent
])


@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA']),
        ...mapState('auth', ['user', 'authUser']),
        ...mapGetters('definitionDesBarres', ['selectedTab']),
        ...mapGetters('definitionBarresStatistiquesConcours', ['stateInfosStatistiquesConcours', 'graphIsLoading'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        ECharts
    }
})
export default class StatistiquesConcours extends Vue {
    @Prop() concour: any

    Ability = Ability
    barres_total = 0
    bar_rules: any = []
    nb_classe = 8
    infosStatConcours: any = []
    option: any  = null

    nb_candidats_inscrits = 0
    nb_candidats_absents = 0
    nb_candidats_elimines = 0
    nb_candidats_admissibles = 0
    classe_values: any = []

    @Watch('selectedTab', { immediate : true })
    watchSelectedTab() {
        if (this.$store.getters['definitionDesBarres/selectedTab'] === 'statistiquesConcours') {
            this.initDatas()
        }
    }

    // Initialisation des datas
    @Watch("$store.state.definitionDesBarres.selectedConcour", { deep : true})
    async initDatas () {
        let barre_absence_id = 0
        this.concour.deliberation.barres
            .find((barre: any) => barre.type === BarTypePass.BAR_TYPE_ANONYMOUS)?.thresholds
            .some((threshold: any) => {
                const bar_rule = this.concour.deliberation.bar_rules
                    .find((bar_rule: any) => bar_rule.id === threshold.bar_rule_id)

                if (bar_rule.type === BarRuleType.BAR_RULE_TYPE_ABSENCE) {
                    barre_absence_id = bar_rule.id
                    return true
                }
            })

        const barres: any = []
        this.$props.concour.deliberation.barres
            .filter((barre: any) => barre.type === BarTypePass.BAR_TYPE_PASS)
            .forEach((barre: any) => {
                barre.thresholds.forEach((threshold: any) => {
                    barres.push(this.$props.concour.deliberation.bar_rules
                        .find((bar_rule: any) => bar_rule.id === threshold.bar_rule_id).id)
                })
            })

        this.bar_rules = this.$props.concour.deliberation.bar_rules
            .filter((bar_rule: any) => barres.includes(bar_rule.id))
            .map((bar_rule: any) => {
                let value: any
                this.concour.deliberation.barres.some((barre: any) => {
                    return barre.thresholds.some((threshold: any) => {
                        if (threshold.bar_rule_id === bar_rule.id) {
                            value = threshold.value
                            return true
                        }
                    })
                })

                return {
                    name: bar_rule.name.charAt(0).toUpperCase() + bar_rule.name.slice(1),
                    id: bar_rule.id,
                    type: bar_rule.type,
                    value: value || null
                }
            })

        if (barre_absence_id) {
            // Récupération du nombre d'absents
            const params_abs = {
                concour_id: this.$props.concour.concour_id,
                phase_id: this.$props.concour.phase_id,
                params: { 'filter-infosRejectionReasons': barre_absence_id }
            }

            this.$store.dispatch('definitionBarresListeNotes/getCandidatAbs', params_abs).then((response) => {
                this.nb_candidats_absents = response.data.meta?.total || 0
            })
        }

        const payload = {
            concour_id: this.$props.concour.concour_id,
            phase_id: this.$props.concour.phase_id
        }
        this.$store.dispatch('definitionBarresStatistiquesConcours/getInfosStatistiquesConcours', payload)
            .then(this.classeValuesCreator)
    }

    // Creation du menu déroulant de nombre de classes en fonction de la barre sélectionnée par user
    @Watch('barres_total')
    classeValuesCreator() {
        this.infosStatConcours = this.$store.getters['definitionBarresStatistiquesConcours/infosStatistiquesConcours'](this.bar_rules, this.nb_classe, this.barres_total)

        // temp est utilisé pour se souvenir du dernier choix de l'utilisateur et configurer nb_classe en fonction.
        const temp = this.classe_values ? this.classe_values.findIndex((classe: { value: number }) => classe.value === this.nb_classe) : null
        if (this.infosStatConcours) {
            this.classe_values = [
                { value: 1, affichage: this.infosStatConcours.meilleure_note[this.barres_total] + ' (' + (this.infosStatConcours.meilleure_note[this.barres_total] / this.infosStatConcours.meilleure_note[this.barres_total]) + ' pts)' },
                { value: this.infosStatConcours.meilleure_note[this.barres_total] / 128, affichage: 128 + ' (' + (Math.round(this.infosStatConcours.meilleure_note[this.barres_total] / 128)) + ' pts)' },
                { value: this.infosStatConcours.meilleure_note[this.barres_total] / 32, affichage: 32 + ' (' + (Math.round(this.infosStatConcours.meilleure_note[this.barres_total] / 32)) + ' pts)' },
                { value: this.infosStatConcours.meilleure_note[this.barres_total] / 20, affichage: 20 + ' (' + (Math.round(this.infosStatConcours.meilleure_note[this.barres_total] / 20)) + ' pts)' },
                { value: this.infosStatConcours.meilleure_note[this.barres_total] / 8, affichage: 8 + ' (' + (Math.round(this.infosStatConcours.meilleure_note[this.barres_total] / 8)) + ' pts)' },
                { value: this.infosStatConcours.meilleure_note[this.barres_total] / 4, affichage: 4 + ' (' + (Math.round(this.infosStatConcours.meilleure_note[this.barres_total] / 4)) + ' pts)' },
                { value: this.infosStatConcours.meilleure_note[this.barres_total] / 2, affichage: 2 + ' (' + (Math.round(this.infosStatConcours.meilleure_note[this.barres_total] / 2)) + ' pts)' },
                { value: this.infosStatConcours.meilleure_note[this.barres_total], affichage: 1 + ' (' + this.infosStatConcours.meilleure_note[this.barres_total] + ' pts)' }
            ]

            this.nb_classe = temp !== -1 && this.classe_values ? this.classe_values[temp].value : this.infosStatConcours.meilleure_note[this.barres_total] / 32
        }
    }

    @Watch('nb_classe')
    @Watch('barres_total')
    // Création des options de graph
    buildChartOptions () {
        this.infosStatConcours = this.$store.getters['definitionBarresStatistiquesConcours/infosStatistiquesConcours'](this.bar_rules, this.nb_classe, this.barres_total)

        // le getter renvois les infos correspondantes au choix utilisateur
        this.nb_candidats_inscrits    = this.concour.candidats_count || 0
        this.nb_candidats_elimines    = this.concour.candidats_count && this.concour.candidats_recus_count ? this.concour.candidats_count - this.concour.candidats_recus_count : 0
        this.nb_candidats_admissibles = this.concour.candidats_recus_count || 0

        this.option = null
        // option du graphique
        this.option =  {
            autoresize: true,
            cursor: 'default',
            calculable: true,
            // legend, dans selected, si pas de barres, on désactive les affichages
            legend: {
                data: [this.infosStatConcours.barre_name1, this.infosStatConcours.barre_name2, this.infosStatConcours.barre_name3],
                selected: { [this.infosStatConcours.barre_name1]: true, [this.infosStatConcours.barre_name2]: !!this.bar_rules[0].value, [this.infosStatConcours.barre_name3]: !!this.bar_rules[1].value }
            },
            dataZoom: [
                {
                    show: true,
                    start: 0,
                    end: this.infosStatConcours.note_max
                }
            ],
            tooltip: {
                trigger: 'item',
                formatter: (seriesIndex: any) => {
                    // si pas d'index superieur, on garde l'affichage de la meilleure note
                    const pointsSuperieur = this.infosStatConcours.axeX[seriesIndex.dataIndex + 1] ? this.infosStatConcours.axeX[seriesIndex.dataIndex + 1] : this.infosStatConcours.meilleure_note[this.barres_total]

                    let affichage = ''
                    let barre_name_screen = ''
                    let totalName = ''

                    // Prefixe pour le premier affichage, le seul non formatté
                    const prefixe_barre_name_screen0 = ' candidats avec '
                    // recuperation des noms des barres.
                    switch (seriesIndex.componentIndex) {
                        case 0:
                            barre_name_screen = this.bar_rules[this.barres_total]?.name ? prefixe_barre_name_screen0 + this.bar_rules[this.barres_total].name : ''
                            affichage = seriesIndex.data + ' ' + barre_name_screen + ' <br>entre  [' + this.infosStatConcours.axeX[seriesIndex.dataIndex] + ' et ' +  pointsSuperieur  + (this.infosStatConcours.axeX[seriesIndex.dataIndex + 1] ? '[' : ']')
                            break
                        case 1:
                            barre_name_screen = this.infosStatConcours.barre_name2
                            totalName = this.bar_rules[this.barres_total]?.name || ''
                            affichage = seriesIndex.data + ' ' + barre_name_screen + '.<br>' + totalName + ' entre  [' + this.infosStatConcours.axeX[seriesIndex.dataIndex] + ' et ' +  pointsSuperieur  + (this.infosStatConcours.axeX[seriesIndex.dataIndex + 1] ? '[' : ']')
                            break
                        case 2:
                            barre_name_screen = this.infosStatConcours.barre_name3
                            totalName = this.bar_rules[this.barres_total]?.name || ''
                            affichage = seriesIndex.data + ' ' + barre_name_screen + '.<br>' + totalName + ' entre  [' + this.infosStatConcours.axeX[seriesIndex.dataIndex] + ' et ' +  pointsSuperieur  + (this.infosStatConcours.axeX[seriesIndex.dataIndex + 1] ? '[' : ']')
                            break
                        default:
                            break
                    }

                    return affichage
                }
            },
            xAxis: [{
                type: 'category',
                data: this.infosStatConcours.axeX
            },
            {
                type: 'value',
                min: 0,
                max: this.infosStatConcours.meilleure_note[this.barres_total],
                show: false
            }
            ],
            yAxis: {
                type: 'value'
            },
            series: [
                {
                    name: this.infosStatConcours.barre_name1,
                    data: this.infosStatConcours.barre1,
                    type: 'bar',
                    showBackground: false,
                    silent: false,
                    color: 'gray'
                },
                {
                    name: this.infosStatConcours.barre_name2,
                    data: this.infosStatConcours.barre2,
                    type: 'bar',
                    showBackground: false,
                    silent: false,
                    color: '#5b9bd5',
                    backgroundStyle: {
                        color: 'rgba(115,165,165,1)'
                    }
                },
                {
                    name: this.infosStatConcours.barre_name3,
                    data: this.infosStatConcours.barre3,
                    type: 'bar',
                    showBackground: false,
                    silent: false,
                    color: '#cfe7dc',
                    backgroundStyle: {
                        color: 'rgba(145,145,145,1)'
                    }
                },
                {
                    xAxisIndex: 1,
                    data : [],
                    type: 'bar',
                    silent:true,
                    markLine : {
                        symbol:['none', 'none'],
                        silent: false, // ignore mouse events
                        data : [
                            // Horizontal Axis (requires valueIndex = 0)
                            {
                                type : 'average',
                                name: 'Moyenne',
                                valueIndex: 0,
                                xAxis: this.bar_rules[this.barres_total].value,
                                itemStyle:{ normal:{ color:'red' } },
                                label: {
                                    color: 'red',
                                    formatter: () =>
                                    {
                                        return this.bar_rules[this.barres_total].value
                                    } // 'Moyenne = ' + moyForChart
                                },

                                lineStyle: {
                                    type: 'solid'
                                }
                            }
                        ]
                    }
                }
            ]
        }
    }

    // Exporte le graph
    exportAsImage (elementDomId: string, rootFileExportName: string) {
        exportDivElementAsImage(elementDomId, rootFileExportName)
    }

}

